"use client"
import { ChevronLeft } from 'lucide-react'
import { signIn } from "next-auth/react";
import Link from 'next/link'
import { Button } from '../ui/button'
import Icons from '../ui/icons'
import { Input } from '../ui/input'
import { Label } from '../ui/label'
import AnimationContainer from "../utils/animation-container"
import { useState } from 'react';
import { useRouter } from "next/navigation";
import { toast } from 'sonner';
import { WrapBg } from '../utils/WrapBg';

const LoginSection = () => {
    const router = useRouter();
    const [value, setValue] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);



    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        if (!value.trim() || !password.trim()) {
            toast.error("خطا", { description: "لطفاً همه فیلدها را پر کنید." });
            setLoading(false);
            return;
        }

        if (password.length < 6) {
            toast.error("خطا", { description: "رمز عبور باید حداقل ۶ کاراکتر باشد." });
            setLoading(false);
            return;
        }

        const res = await signIn("credentials", {
            identifier: value,
            password,
            redirect: false,
        });

        if (res?.error) {
            setLoading(false);



            toast.error("خطا", { description: res?.error || "رمز عبور اشتباه یا کاربری اشتباه می باشد." });
        } else {
            toast.success('ورود موفق', { description: "در حال هدایت به صفحه داشبورد" });
            setLoading(false);
            router.push("/dashboard");
        }
    };
    return (
        <section className="flex flex-col items-center justify-center w-full relative">
            <div className="bg-background grid grid-cols-1 min-h-screen lg:h-screen overflow-y-hidden scrollbar-hide lg:grid-cols-2 w-full">

                <AnimationContainer reverse className="absolute top-4 md:top-8 left-4 md:left-8 z-50">
                    <div className="flex items-center">
                        <Button size="sm" variant="outline" asChild>
                            <Link href="/">
                                برگشت
                                <ChevronLeft className="w-4 h-4 mr-1" />
                            </Link>
                        </Button>
                    </div>
                </AnimationContainer>

                <AnimationContainer delay={0.1}>
                    <div
                        style={{
                            backgroundImage: "url('/images/bg-4.jpg')",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",

                        }}
                        className="bg-muted/30 relative h-full w-full hidden lg:block">
                        <div className="flex w-4/5 mx-auto lg:px-8 items-center justify-center h-full">
                            {/* <Images.auth className="h-full w-full" /> */}
                            <WrapBg />
                        </div>
                        <div className="flex flex-col items-center absolute left-1/2 bottom-[15%] -translate-x-1/2 ranslate-y-1/2 justify-center max-w-sm">
                            <h1 className="text-xl md:text-2xl font-semibold text-center">
                                با مخاطبان خود ارتباط برقرار کنید
                            </h1>
                            <p className="text-muted-foreground mt-2 text-sm md:text-base text-center">
                                با نام فروشگاه ، می توانید با مخاطبان خود ارتباط برقرار کرده و اثر برند خود را رشد دهید بیشتر بدانید
                            </p>
                            <Button size="sm" variant="white" className="mt-4">
                                <Link href="/blog">
                                    بیشتر یاد بگیرید
                                </Link>
                            </Button>
                        </div>
                    </div>
                </AnimationContainer>

                <AnimationContainer delay={0.2}>
                    <div className="flex mt-16 justify-center py-12 relative px-4 md:px-0">
                        <div className="mx-auto grid max-w-sm w-full gap-6">
                            <div className="flex flex-col gap-4 text-start">
                                <h1 className="text-2xl font-semibold">
                                    خوش برگشتی
                                </h1>
                                <p className="text-muted-foreground">
                                    خوشحالم که دوباره شما را می بینم! لطفا برای ادامه ورود به سیستم
                                </p>
                            </div>
                            <div className="grid mt-2 w-full gap-4">
                                <div className="grid gap-2">
                                    <Label htmlFor="value">ایمیل، یوزرنیم یا تلفن همراه</Label>
                                    <Input
                                        id="value"
                                        type="text"
                                        placeholder="ادرس ایمیل، یوزرنیم یا تلفن همراه خود را قرار دهید"
                                        value={value}
                                        onChange={(e) => setValue(e.target.value)}
                                    />
                                </div>
                                <form onSubmit={handleSubmit} className='flex flex-col gap-3'>
                                    <div className="grid gap-2">
                                        <div className="flex items-center">
                                            <Label htmlFor="password">رمز عبور</Label>
                                            <Link
                                                href="/auth/forgot-password"
                                                className="mr-auto inline-block text-sm underline"
                                            >
                                                رمز عبور خود را فراموش کردید ؟
                                            </Link>
                                        </div>
                                        <Input
                                            id="password"
                                            type="password"
                                            placeholder="رمز عبور شما"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                    <Button type="submit" className="w-full" disabled={loading}>
                                        {loading ? 'در حال ورود...' : 'ورود'}
                                    </Button>
                                </form>
                                <div className="flex items-center justify-center w-full my-2">
                                    <div className="h-px bg-border w-full"></div>
                                    <p className="text-muted-foreground mx-2">یا</p>
                                    <div className="h-px bg-border w-full"></div>
                                </div>
                                <Button onClick={() => signIn("google")} variant="subtle" className="w-full">
                                    <Icons.google className="w-4 h-4 ml-2" />
                                    ورود از طریق گوگل
                                </Button>
                                <Link href="/auth/verify-phone">
                                    <Button variant="subtle" className="w-full">
                                        <Icons.call className="w-5 h-5 ml-2" />
                                        ورود با شماره تلفن
                                    </Button>
                                </Link>
                                {/* <Button variant="subtle" className="w-full mt-2">
                                    <Icons.github className="w-5 h-5 ml-2" />
                                    Sign In with Github
                                </Button> */}
                            </div>
                            <div className="mt-4 text-center text-sm">
                                حساب کاربری ندارید؟{" "}
                                <Link href="/auth/signup" className="text-primaryLight">
                                    ثبت نام کنید
                                </Link>
                            </div>
                        </div>
                    </div>
                </AnimationContainer>

            </div>
        </section>
    )
};

export default LoginSection
